"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatelessCheckbox = exports.Checkbox = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const S = __importStar(require("./Checkbox.styles"));
const icons_1 = require("../icons");
exports.Checkbox = ({ defaultChecked = false, onPress, disabled, testID, accessibilityLabel, accessibilityHint, }) => {
    const [checked, setChecked] = react_1.useState(defaultChecked);
    const onChecked = () => {
        if (onPress) {
            onPress(!checked);
        }
        setChecked(!checked);
    };
    return (react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { testID: testID, onPress: onChecked, accessibilityRole: "checkbox", accessibilityState: { checked }, accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, disabled: disabled },
        react_1.default.createElement(S.CheckBox, { checked: checked, disabled: disabled, testID: "checkbox" }, checked && react_1.default.createElement(icons_1.Tick, null))));
};
exports.StatelessCheckbox = ({ isChecked = false, onPress, disabled, testID, accessibilityLabel, accessibilityHint, }) => {
    const onChecked = () => {
        if (onPress) {
            onPress();
        }
    };
    return (react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { testID: testID, onPress: onChecked, accessibilityRole: "checkbox", accessibilityState: { checked: isChecked }, accessibilityLabel: accessibilityLabel, accessibilityHint: accessibilityHint, disabled: disabled },
        react_1.default.createElement(S.CheckBox, { checked: isChecked, disabled: disabled, testID: "checkbox" }, isChecked && react_1.default.createElement(icons_1.Tick, null))));
};
